import React from "react";
import Container, {ContainerProps} from "../../../common.blocks/Container/Container";

import "./BannerContainer.css";

export default function BannerContainer(props: ContainerProps){
    return <Container classList={["banner__container"]} {...props}/>;
}